export default {
  submit: '送信',
  save: '保存',
  close: '閉じる',
  loading: "処理中...",
  header: {
    allProduct: "カテゴリ",
    searchPlaceholder: "検索内容を入力してくだい",
    accountOrder: "注文履歴",
    accountCollect: "気に入り",
    accountIntegral: "Myポイント",
    accountCoupon: "Myクーポン",
    logout: "ログアウト",
    hotRecommend: '人気商品',
    searchHistory: '検索履歴',
    empty: 'クリア',
    more: 'More'
  },
  page: {
    pagesize: '条/页',
    goto: '前往',
    pageClassifier: '页',
    total: '共 {total} 条'
  },
  image: {
    error: 'ロード失敗'
  },
  upload: {
    deleteTip: '削除'
  },
  selectRegion: {
    userAddressTitle: "アドレス帳",
    selectAddressTitle: "住所選択"
  },
  yes: 'はい',
  no: 'いいえ',
  sellOff: '処分中',
  verticalReductionActivity: '定額割引(￥)',
  discountActivity: '定額割引(%)',
  verticalReductionActivityCoupon: '円OFF券',
  discountActivityCoupon: '%OFF券',
  freeShippingyCoupon: '送料無料券',
  addShoppingCart: 'カートに入れる',
  pointNumber: 'ポイント{productPointNum}倍',
  stockout: '入庫待ち',
  edit: '編集',
  delete: '削除',
  pleaseSelect: '選択してください',
  pleaseInput: '入力してください',
  confirm: 'OK',
  cancel: 'キャンセル',
  detail: '详情',
  productName: '商品名',
  productNo: '商品ｺｰﾄﾞ',
  specification: '規格',
  orderNo: '注文番号',
  amount: '数量',
  productPrice: '単価',
  subtotal: '商品小計',
  productSubtotal: '商品小計',
  coupon: 'クーポン',
  freight: '運賃',
  totalPrice: '合計金額',
  prompt: '注意',
  orderStatus1: "支払待",
  orderStatus2: "処理待",
  orderStatus3: "ピッキング中",
  orderStatus4: "ピッキング中",
  //拣货中,前台不显示这个状态
  orderStatus5: "出荷済",
  orderStatus6: "注文完了",
  orderStatus7: "キャンセル済",
  commonHint: 'お知らせ',
  noRecord: '該当内容がありません',
  addCartSuccess: 'カートに入れました',
  unSet: '指定しない',
  beforeNoon: '午前中',
  captchaSentSuccessfully: '認証コードを送信しました',
  OYX: '認証完了しました',
  updateSuccessfully: '更新しました',
  addSuccessfully: '登録しました',
  deleteSuccessfully: '削除しました',
  thousand: '千',
  tenThousand: '万',
  fastTimeRecive: '最短日',
  selectReciveDate: '配達時間を指定してください',
  couponList: 'クーポン一覧',
  footer: {
    informationConsultantTitle: "ｲﾝﾌｫｰﾒｰｼｮﾝ",
    informationConsultant1: "クーポン利用方法",
    informationConsultant2: "大口注文",
    informationConsultant3: "よくあるご質問",
    informationConsultant4: "コンビニ決済方法",
    informationConsultant5: "お取引先募集",
    shoppingRelatedTitle: "購入関係",
    shoppingRelated1: "本月特売",
    shoppingRelated2: "ポイントについて",
    shoppingRelated3: "利用案内",
    customerServiceTitle: "ｶｽﾀﾏｰｻｰﾋﾞｽ",
    customerService1: "注文履歴",
    customerService2: "お気に入り",
    customerService3: "メルマガ",
    otherTitle: "その他",
    other1: "本味主義について",
    footer1: "利用規約",
    footer2: "特定商取引法に基づく表記",
    footer3: "個人情報保護方針"
  },
  timeOutTip: "タイムアウト",
  no_coupon: '登録可能なクーポンがありません',
  no_existence_coupon: '該当クーポンが存在しません',
  information: "記事",
  accessPasswordNull: 'パスワードを入力してください。',
  indexPage: 'ホーム',
  check_article_exist: "このページが存在しません",
  offShelves: "終売",
  levelUpTip1: "こちらがテストサイトです。本番サイトは",
  levelUpTip2: "からアクセスしてください。",
  bunding: '同梱'
};